module.exports = __webpack_public_path__ + "img/aeroland-client-logo-01-hover.1fb6d7c8.png";